<template>
    <transition name="slide">
        <div v-if="visible" class="drop">
            <slot></slot>
        </div>
    </transition>
</template>

<script>

    export default {
        name: 'dropdown-item-component',
        props: {
            visible: Boolean
        },
    }
</script>


<style scoped>
    .drop {
        max-height: 10000px;
    }
    .slide-leave-active {
        transition: opacity 1s,  max-height .4s ease-out;
    }
    .slide-enter-active {
        transition: opacity 1s, max-height .4s ease-in;
    }
    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
        opacity: 0;
    }

    .slide-enter-to, .slide-leave {
        overflow: hidden;
    }

</style>
